// extracted by mini-css-extract-plugin
module.exports = {"aff_loading":"D7ys0","affspin":"Ox51Q"};